<script setup lang="ts">
import { type HTMLAttributes } from 'vue'
import { cn } from '@/lib/utils'

const props = defineProps<{
    class?: HTMLAttributes['class']
}>()
</script>

<template>
    <!--
        Two shadows, not one: a tight contact shadow that draws the card's edge and a
        wide soft one that lifts it off the page. A single flat shadow reads as a border
        and leaves the card sitting in the page rather than on it. In dark the card's own
        lighter surface does the lifting, so the shadow is dropped.
    -->
    <div
        :class="
            cn(
                'rounded-xl border bg-card text-card-foreground shadow-[0_1px_2px_0_rgb(0_0_0/0.05),0_8px_20px_-8px_rgb(0_0_0/0.12)] dark:shadow-none',
                props.class,
            )
        "
    >
        <slot />
    </div>
</template>
